import React from 'react'
import types from 'prop-types'
import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { openOutbound, setCurrentDataOutbound } from 'redux/outbound/actions'
import { offlineChannels } from 'constants/channels'
import { I18n } from 'react-redux-i18n'
import FilterMenu from 'components/FilterMenu'
import { CHAT_FILTERS_OPTIONS } from '../../../../constants'
import { lang } from 'utils/helpers'

const WITH_TAGS = ['facebook', 'instagram']
const COMPANY_WITHOUT_OUTBOUND = ['632c166b5600cd0014c4b7e8']

const ConversationOffline = (props) => {
  const {
    user, isNote: note, onToggleNote, isOnline, useTemplate,
    setUseTemplate, channel, composer, filterText,
    handleFiltersMessages, resetMessageFilters,
    filterValue } = props
  const { isRemoveByUser } = user
  const dispatch = useDispatch()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    return () => {
      setUseTemplate(false)
      setIsVisible(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if ((!note && !isOnline) || (!useTemplate && !isOnline) || isRemoveByUser) {
      setIsVisible(true)
    }
    if (note || useTemplate || isOnline) {
      setIsVisible(false)
    }
    if (composer.selectedTemplate || (composer.tag && WITH_TAGS.includes(channel))) {
      setIsVisible(false)
      setUseTemplate(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id, note, isOnline, useTemplate, channel, composer])

  const openOutboundModal = (channel) => {
    if ((['sms', 'whatsapp'].includes(channel) && user.phone) || (channel === 'chatmail' && user.email)) {
      const outboundData =  {
        channel,
        to: {
          chips: [{
            value: ['chatmail'].includes(channel) ? user.email : user.phone,
            name: user.name,
            isValid: true
          }]
        }
      }
      dispatch(setCurrentDataOutbound({ outboundCurrentData: outboundData }))
    }
    else {
      dispatch(openOutbound({ channel }))
    }
  }

  const getFilterOptions = () => {
    try {
      const filterOptions = []

      CHAT_FILTERS_OPTIONS.forEach(filter => {
        filterOptions.push({
          type: filter.name,
          value: filterValue?.includes(filter.name) || false,
          iconName: filterValue?.includes(filter.name) || false ? filter.activeIcon : filter.icon,
          name: lang(filter.text)
        })
      })

      return filterOptions
    } catch (error) {
      console.error('error: ', error)
    }
  }

  if (!isVisible) return null
  if (!offlineChannels.includes(channel) && !isRemoveByUser ) return null

  return (
    <div className='conversation-offline fadeIn animated'>
      <div className='offline-inner'>

        <img className='offline-icon-blocked' src={getStaticImage('/icons/orange-brand/icon-blocked-red.svg')} alt={'blocked'} />

        <div className='offline-seccion-one'>
          <label>
            {I18n.t(`offline_text1_${isRemoveByUser ? 'states_removeByUser' : channel}`)}
            {isRemoveByUser && <strong>{I18n.t('offline_text1_strong')}</strong>}
          </label>
          <legend>
            {I18n.t(`offline_text2_${isRemoveByUser ? 'states_removeByUser' : channel}`)}
            {isRemoveByUser && <strong>{I18n.t('offline_text2_strong')}</strong>}
            { isRemoveByUser &&
              <>
                <br/>
                {I18n.t('offline_text3_removeByUser')}
                {isRemoveByUser && <strong>{I18n.t('offline_text3_strong')}</strong>}
              </>
            }
          </legend>
        </div>

        <div className='offline-seccion-two'>
          {
            channel !== 'chatweb' && !isRemoveByUser
              ?
              <div className='offline-seccion-icon' onClick={()=>{setIsVisible(false); setUseTemplate(true)}}>
                <img src={getStaticImage(`/channels/orange-brand/${channel}-icon.svg`)} alt={'whatsapp'}/>
                <label>{I18n.t('offline_template')}</label>
              </div>
              :
              null
          }
          {
            channel === 'chatweb' && !isRemoveByUser &&
            <div className='offline-seccion-icon' onClick={()=>openOutboundModal('whatsapp')}>
              <img src={getStaticImage(`/channels/orange-brand/whatsapp-icon.svg`)} alt={'whatsapp'}/>
              <label>{I18n.t('offline_template')}</label>
            </div>
          }
          {
            !COMPANY_WITHOUT_OUTBOUND.includes(user.company) && !isRemoveByUser && (
              <div className='offline-seccion-icon' onClick={()=>openOutboundModal('sms')}>
                <img src={getStaticImage('/channels/orange-brand/sms-icon.svg')} alt={'sms'}/>
                <label>{I18n.t('offline_sms')}</label>
              </div>
            )
          }
          {
            !COMPANY_WITHOUT_OUTBOUND.includes(user.company) && !isRemoveByUser && (
              <div className='offline-seccion-icon' onClick={()=>openOutboundModal('chatmail')}>
                <img src={getStaticImage('/channels/orange-brand/chatmail-icon.svg')} alt={'chatmail'}/>
                <label>{I18n.t('offline_email')}</label>
              </div>
            )
          }
          <button
            title={I18n.t('offline_note_title')}
            className='offline-icon-note'
            onClick={onToggleNote}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-note.svg')} alt='Note' />
            </figure>
          </button>
          <div className='offline-filter'>
            <FilterMenu
              searchValue={filterText !== ''? filterText : ''}
              options={getFilterOptions()}
              onChange={handleFiltersMessages}
              handleReset={resetMessageFilters}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ConversationOffline.propTypes = {
  user: types.any.isRequired,
  isNote: types.bool.isRequired,
  onToggleNote: types.func.isRequired,
  isOnline: types.bool.isRequired,
  useTemplate: types.bool.isRequired,
  setUseTemplate: types.any.isRequired,
  channel: types.string.isRequired,
  composer: types.object,
  filterValue: types.array,
  filterText: types.string,
  handleFiltersMessages: types.func,
  resetMessageFilters: types.func,
  companies: types.object
}

export default ConversationOffline
